module.exports = __webpack_public_path__ + "static/media/ic_person_white_24px.990364a0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/views/misc/svg/ic_person_white_24px.svg
// module id = 350
// module chunks = 0